import React from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon,
  MenuList,
  MenuListItem,
  HOCs,
} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { KnowledgeMapIconIds } from 'constants/knowledgeMap';
import BaseMoreButton from 'components/MoreButton';
import { Menu, MenuListItemText } from './styles';
import messages from './messages';

const { enhanceWithPopper } = HOCs;

const MoreButtonWithPopper = enhanceWithPopper(BaseMoreButton);

const CompetencyDocumentItemMenu = ({ 
  competencyDocumentItem, 
  duplicateItemMenuClickHandler,
  deleteItemClickHandler,
}) => (
  <MoreButtonWithPopper placement="bottom-end" hidepopperonclick>
    <Menu>
      <MenuList>
        <MenuListItem 
          key={KnowledgeMapIconIds.CONTENT_COPY} 
          onClick={() => duplicateItemMenuClickHandler(competencyDocumentItem)}
        >
          <MaterialIcon id={KnowledgeMapIconIds.CONTENT_COPY} />
          <MenuListItemText>
            {intl.formatMessage(messages.duplicateItem)}
          </MenuListItemText>
        </MenuListItem>
        <MenuListItem 
          key={KnowledgeMapIconIds.DELETE} 
          onClick={() => deleteItemClickHandler(competencyDocumentItem)}
        >
          <MaterialIcon id={KnowledgeMapIconIds.DELETE} />
          <MenuListItemText>
            {intl.formatMessage(messages.deleteItem)}
          </MenuListItemText>
        </MenuListItem>
      </MenuList>
    </Menu>
  </MoreButtonWithPopper>
);

CompetencyDocumentItemMenu.propTypes = {
  competencyDocumentItem: PropTypes.object.isRequired,
  duplicateItemMenuClickHandler: PropTypes.func,
};

export default CompetencyDocumentItemMenu;